/**
 * Identifiants tirés par le téléphone : `envoiId` d'une clôture ou d'une
 * évaluation, marque d'onglet. `crypto.randomUUID` n'existe qu'en contexte
 * sécurisé : sur `http://IP:5173` on retombe sur `getRandomValues`, qui y reste
 * disponible, et le résultat garde la forme d'un uuid v4 (l'API le vérifie).
 */

type SourceAleatoire = Partial<Pick<Crypto, 'randomUUID' | 'getRandomValues'>>;

export function nouvelIdentifiant(source: SourceAleatoire | undefined = globalThis.crypto): string {
  if (typeof source?.randomUUID === 'function') {
    try {
      return source.randomUUID();
    } catch {
      /* contexte non sécurisé selon le navigateur : repli ci-dessous */
    }
  }
  const octets = new Uint8Array(16);
  if (typeof source?.getRandomValues === 'function') {
    source.getRandomValues(octets);
  } else {
    // Navigateur sans Web Crypto : l'unicité suffit ici, rien n'est secret.
    for (let i = 0; i < octets.length; i += 1) octets[i] = Math.floor(Math.random() * 256);
  }
  octets[6] = (octets[6]! & 0x0f) | 0x40; // version 4
  octets[8] = (octets[8]! & 0x3f) | 0x80; // variante RFC 4122
  const hex = Array.from(octets, (octet) => octet.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Marque de cet onglet (brouillon écrit ailleurs, diffusion). */
export const ID_ONGLET: string = nouvelIdentifiant();
